export const RENEWALS_START = 'RENEWALS_START';
export const RENEWALS_SUCCESS = 'RENEWALS_SUCCESS';
export const RENEWALS_ERROR = 'RENEWALS_ERROR';
export const RENEWALS_LOADING = 'RENEWALS_LOADING';
export const RENEWALS_CANCEL = 'RENEWALS_CANCEL';
export const PROMOCODEINQ_START = 'PROMOCODEINQ_START';
export const PROMOCODEINQ_SUCCESS = 'PROMOCODEINQ_SUCCESS';
export const PROMOCODEINQ_ERROR = 'PROMOCODEINQ_ERROR';
export const PROMOCODEINQ_LOADING = 'PROMOCODEINQ_LOADING';
export const PROMOCODEINQ_CANCEL = 'PROMOCODEINQ_CANCEL';
export const ORDERFORECAST_START = 'ORDERFORECAST_START';
export const ORDERFORECAST_SUCCESS = 'ORDERFORECAST_SUCCESS';
export const ORDERFORECAST_ERROR = 'ORDERFORECAST_ERROR';
export const ORDERFORECAST_LOADING = 'ORDERFORECAST_LOADING';
export const ORDERFORECAST_CANCEL = 'ORDERFORECAST_CANCEL';
export type Actions = {
  RENEWALS_START: { type: typeof RENEWALS_START; payload: boolean };
  RENEWALS_LOADING: { type: typeof RENEWALS_LOADING; payload: boolean };
  RENEWALS_SUCCESS: { type: typeof RENEWALS_SUCCESS; payload: any };
  RENEWALS_ERROR: { type: typeof RENEWALS_ERROR; payload: any };
  RENEWALS_CANCEL: { type: typeof RENEWALS_CANCEL; payload: any };
  PROMOCODEINQ_START: { type: typeof PROMOCODEINQ_START; payload: boolean };
  PROMOCODEINQ_LOADING: { type: typeof PROMOCODEINQ_LOADING; payload: boolean };
  PROMOCODEINQ_SUCCESS: { type: typeof PROMOCODEINQ_SUCCESS; payload: any };
  PROMOCODEINQ_ERROR: { type: typeof PROMOCODEINQ_ERROR; payload: any };
  PROMOCODEINQ_CANCEL: { type: typeof PROMOCODEINQ_CANCEL; payload: any };
  ORDERFORECAST_START: { type: typeof ORDERFORECAST_START; payload: boolean };
  ORDERFORECAST_LOADING: { type: typeof ORDERFORECAST_LOADING; payload: boolean };
  ORDERFORECAST_SUCCESS: { type: typeof ORDERFORECAST_SUCCESS; payload: any };
  ORDERFORECAST_ERROR: { type: typeof ORDERFORECAST_ERROR; payload: any };
  ORDERFORECAST_CANCEL: { type: typeof ORDERFORECAST_CANCEL; payload: any };
};
// Action Creators
export const actionCreators = {
  renewalsStart: (payload: any): Actions[typeof RENEWALS_START] => ({
    type: RENEWALS_START,
    payload,
  }),
  renewalsError: (payload: any): Actions[typeof RENEWALS_ERROR] => ({
    type: RENEWALS_ERROR,
    payload,
  }),
  renewalsSuccess: (payload: any): Actions[typeof RENEWALS_SUCCESS] => {
    return ({ type: RENEWALS_SUCCESS, payload: payload});
  },
  renewalsLoading: (payload: boolean): Actions[typeof RENEWALS_LOADING] => ({
    type: RENEWALS_LOADING,
    payload,
  }),
  renewalsCancel: (payload: boolean): Actions[typeof RENEWALS_CANCEL] => ({
    type: RENEWALS_CANCEL,
    payload,
  }),
  promoCodeInqStart: (payload: any): Actions[typeof PROMOCODEINQ_START] => ({
    type: PROMOCODEINQ_START,
    payload,
  }),
  promoCodeInqError: (payload: any): Actions[typeof PROMOCODEINQ_ERROR] => ({
    type: PROMOCODEINQ_ERROR,
    payload,
  }),
  promoCodeInqSuccess: (payload: any): Actions[typeof PROMOCODEINQ_SUCCESS] => {
    return ({ type: PROMOCODEINQ_SUCCESS, payload: payload});
  },
  promoCodeInqLoading: (payload: boolean): Actions[typeof PROMOCODEINQ_LOADING] => ({
    type: PROMOCODEINQ_LOADING,
    payload,
  }),
  promoCodeInqCancel: (payload: boolean): Actions[typeof PROMOCODEINQ_CANCEL] => ({
    type: PROMOCODEINQ_CANCEL,
    payload,
  }),
  orderForecastStart: (payload: any): Actions[typeof ORDERFORECAST_START] => ({
    type: ORDERFORECAST_START,
    payload,
  }),
  orderForecaseError: (payload: any): Actions[typeof ORDERFORECAST_ERROR] => ({
    type: ORDERFORECAST_ERROR,
    payload,
  }),
  orderForecastSuccess: (payload: any): Actions[typeof ORDERFORECAST_SUCCESS] => {
    return ({ type: ORDERFORECAST_SUCCESS, payload: payload});
  },
  orderForecastLoading: (payload: boolean): Actions[typeof ORDERFORECAST_LOADING] => ({
    type: ORDERFORECAST_LOADING,
    payload,
  }),
  orderForecastCancel: (payload: boolean): Actions[typeof ORDERFORECAST_CANCEL] => ({
    type: ORDERFORECAST_CANCEL,
    payload,
  }),
};
